import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import NavBar from "./components/NavBar";
import Banner from "./components/Banner";
import Contact from "./components/Contact";
import Availability from "./components/Availability";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Filler from "./components/Filler-area";
import Services from "./components/Services";
import Footer from "./components/Footer";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <NavBar />
        <main>
          <Banner />
          <Services />
          <Experience />
          <Projects />
          <Availability />
          <Filler />
          <Contact />
        </main>
        <Footer />
      </ErrorBoundary>
    </div>
  );
}

export default App;
